<template>
  <div class="app-container">

    <!-- 查询和其他操作 -->
    <div class="filter-container">
      <el-input v-model="listQuery.name" clearable class="filter-item" style="width: 200px;" placeholder="请输入画像名称" />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>

    <!-- 查询结果 -->
    <el-table v-loading="listLoading" :data="list" element-loading-text="正在查询中。。。" border fit highlight-current-row>

      <el-table-column align="center" label="画像名称" prop="name" sortable="" />

      <el-table-column align="center" label="是否启用" prop="deleted">
        <template slot-scope="scope">
          <el-tag :type="scope.row.deleted ? 'success' : 'danger' ">{{ scope.row.deleted ? '不启用' : '启用' }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="预计人数" prop="people" />
      <el-table-column align="center" label="创建时间" prop="createTime" />

      <el-table-column align="center" label="操作" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button type="text" icon="el-icon-close" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          <el-button v-show="scope.row.people<=0" type="text" icon="el-icon-user" size="mini" @click="handleEtl(scope.row)">立即执行</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <!-- 标签筛选 -->
    <el-dialog title="画像标签筛选" :visible.sync="dialogConditionVisible" width="1000px">
      <el-form ref="filterForm" :loading="condidtionLoading" :rules="rules" :model="conditionForm" status-icon label-position="left" label-width="120px" style="width: 960px; margin-left:30px;">

        <el-row style="margin-top:10px">
          <el-col :span="16">
            <el-form-item label="画像名称" prop="name">
              <el-input v-model="conditionForm.name" size="mini" placeholder="请输入画像名称" />
            </el-form-item>

            <!-- <el-form-item label="预测建议" prop="proposal">
              <el-input v-model="conditionForm.proposal" size="mini" placeholder="请输入此画像客户的预测建议" />
            </el-form-item> 

            <el-form-item label="自定义sql" prop="customSql">
              <el-input type="textarea" v-model="conditionForm.customSql" placeholder="请输入自定义sql 例子: and id in (select * from table)" :autosize="{ minRows: 2, maxRows: 4}" />
            </el-form-item>-->

            <el-form-item label="画像说明" prop="remark">
              <el-input v-model="conditionForm.remark" size="mini" placeholder="请输入画像说明" />
            </el-form-item>

            <div v-for="item in labelList" v-bind:key="item.id">
              <fieldset>
                <legend class="text-center text-primary">{{ item.name }}</legend>
                <div v-for='(label,index) in item.children' v-bind:key="label.id">
                  <div v-show="index<3||label.isHide==false" class="label-contain">
                    <span class="title">{{ label.name }}:</span>
                    <template v-if="label.property=='int'">
                      <el-input type="number" size="mini" clearable="" v-model="label.conditionStart" style=";margin:0 10px" placeholder="请输入开始值"></el-input>
                      <el-input type="number" size="mini" clearable="" v-model="label.conditionEnd" style="margin:0 10px" placeholder="请输入结束值"></el-input>
                    </template>
                    <template v-if="label.property=='date'">
                      <el-date-picker type="datetimerange" clearable="" v-model="label.conditionStart" size="mini" style="margin-left:10px;width:auto" class="filter-item" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="{}" />
                    </template>
                    <div v-if="label.property=='enum'" style="margin-left:5px;display:flex;flex-wrap: wrap;">
                      <!-- <el-select v-model="label.conditionStart" multiple="" size="mini">
                        <el-option v-for="value in label.value.split(',')"  :label="value" :key="value" :value="value"/>
                      </el-select> -->
                      <el-button @click="btnEnumClick(label,value)" v-bind:class="label.conditionStart.indexOf(value)>=0?'active':''" v-for="value in label.value.split(',')" style="margin:5px" v-bind:key="value" size="mini">
                        {{value}}
                        <i v-show="label.conditionStart.indexOf(value)>=0" class="el-icon-check"></i>
                      </el-button>
                    </div>
                    <template v-if="label.property=='string'">
                      <el-input size="mini" clearable style="margin:0 10px" v-model="label.conditionStart" placeholder="请输入筛选值"></el-input>

                      <!-- <el-button class="search-btn" size="mini" type="text">
                      加条件
                      <i class="el-icon-plus"></i>
                    </el-button> -->
                    </template>
                    <el-dropdown size="small" placement="bottom" trigger="click" @command="symbolChange" style="margin-left: 10px;">
                      <el-button class="search-btn" size="mini" type="text">关系：<span style="color:#606266">{{label.symbol}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="beforeHandleSymbol(label,'and')">and</el-dropdown-item>
                        <!--<el-dropdown-item :command="beforeHandleSymbol(label,'or')">or</el-dropdown-item> 
                        <el-dropdown-item :command="beforeHandleSymbol(label,'in')">in</el-dropdown-item>-->
                        <el-dropdown-item :command="beforeHandleSymbol(label,'notin')">not in</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div style="display:block;text-align: right;cursor:pointer;color: #09afff;" v-if="item.children.length>3" @click="btnMoreLabel(item)">
                  <i v-show="item.isHide" class="el-icon-arrow-down">更多标签</i>
                  <i v-show="!item.isHide" class="el-icon-arrow-up">隐藏标签</i>
                </div>

              </fieldset>
            </div>
          </el-col>
          <el-col :span="8">
            <fieldset ref="filterDialog">
              <legend class="text-center text-primary">选中的标签</legend>
              <div style="font-weight: 700;margin-bottom:10px">画像名称：{{conditionForm.name}}</div>
              <div v-for="item  in labelList" v-bind:key="item.id">
                <div v-for="label  in item.children" v-bind:key="label.id">
                  <div v-show="label.conditionStart!=null&&label.conditionStart!=''">
                    <span class="condidtion-title">{{label.name}}：</span>
                    <span class="condition">{{label.conditionStart}}</span>
                    <span class="condition" v-show="label.conditionEnd!=null&&label.conditionEnd!=''">至{{label.conditionEnd}}</span>
                    <span class="symbol">{{label.symbol}}</span>
                    <i class="el-icon-close el-icon--right" style="color:red;cursor:pointer" title="删除" @click="btnDeleteCondition(label)"></i>
                  </div>
                </div>
              </div>
              <div slot="footer" class="dialog-footer" style="margin-top:30px">
                <span style="color:#09afff;margin-right:10px">人数：{{conditionForm.people}}人</span>
                <el-button type="info" :loading="estimateLoading" size="mini" @click="handleEstimate">人数预估</el-button>
                <div style="height: 60px;line-height: 60px;border-top: 1px dashed #dfe6ec;margin-top: 10px;">
                  <el-button type="primary" :loading="condidtionSaveLoading" size="mini" @click="handleSaveCondition">保存画像</el-button>
                </div>
              </div>
            </fieldset>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogConditionVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import service from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";

export default {
  name: "dimProfile",
  components: { Pagination },
  filters: {},
  data() {
    return {
      list: [],
      estimateLoading: false,
      dialogConditionVisible: false,
      condidtionSaveLoading: false,
      condidtionLoading: false,
      conditionForm: {
        id: 0,
        name: "",
        remark: "",
      },
      labelList: [],
      scrollTop: 0, //随动窗口
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
        status: undefined,
        sort: "create_time",
        order: "desc",
      },
      rules: {
        name: [
          { required: true, message: "画像标题不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    console.log(document.getElementsByClassName("el-dialog__wrapper"));
    document
      .getElementsByClassName("el-dialog__wrapper")[2]
      .addEventListener("scroll", this.scrollToView);
  },
  created() {
    this.getList();
  },
  methods: {
    scrollToView(e) {
      console.info("scrollToView");
      if (this.dialogFilterVisible == false) return;

      // dom滚动位置
      var scrollTop =
        window.pageYOffset || e.target.scrollTop || e.target.scrollTop;

      this.$refs.filterDialog.style.marginTop = scrollTop + "px";
    },
    getList() {
      this.listLoading = true;
      service
        .$axiosDimProfileList(this.listQuery)
        .then((response) => {
          this.list = response.data.data.list;
          this.total = response.data.data.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.total = 0;
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm() {
      this.conditionForm = {
        id: undefined,
        deleted: false,
        name: undefined,
        people: 0,
        remark: undefined,
        proposal: "",
        labels: [],
      };
    },
    handleCreate() {
      this.resetForm();
      this.handleCondition(this.conditionForm);
    },
    handleUpdate(row) {
      this.conditionForm = Object.assign({}, row);
      this.handleCondition(this.conditionForm);
    },
    handleDelete(row) {
      this.$confirm(
        "删除画像后，相应的客户标记也将删除，影响配置此画像的任务、市场部活动，确定要删除吗？",
        "提示",
        {
          confirmButtonText: "立即执行",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        service
          .$axiosDimProfileDelete(row)
          .then((response) => {
            this.$notify.success({
              title: "成功",
              message: "停用标签成功",
            });
            const index = this.list.indexOf(row);
            this.list.splice(index, 1);
          })
          .catch((response) => {
            this.$notify.error({
              title: "失败",
              message: response.data.errmsg,
            });
          });
      });
    },
    beforeHandleSymbol(label, symbol) {
      return {
        label: label,
        symbol: symbol,
      };
    },
    symbolChange(command) {
      command.label.symbol = command.symbol;
    },
    addLabel() {
      //新增标签
    },
    btnEnumClick(label, btn) {
      //枚举类型按钮事件
      if (label.conditionStart.indexOf(btn) >= 0) {
        label.conditionStart = label.conditionStart.replace(btn + ",", "");
      } else {
        label.conditionStart = label.conditionStart + btn + ",";
      }
    },
    btnDeleteCondition(label) {
      if (label.property == "date") {
        label.conditionStart = [];
      } else {
        label.conditionStart = "";
        label.conditionEnd = "";
      }
    },
    valid() {
      var data = [];
      let result = this.labelList.some((item) => {
        return item.children.some((label) => {
          if (label.conditionStart != null && label.conditionStart != "") {
            let obj = Object.assign({}, label);
            if (obj.property == "date") {
              obj.conditionStart = label.conditionStart[0];
              obj.conditionEnd = label.conditionStart[1];
            } else if (obj.property == "int") {
              if (label.conditionEnd == null || label.conditionEnd == "") {
                this.$notify.error({
                  title: "失败",
                  message: "请输入" + label.name + "的截至值",
                });
                return true;
              }
            }
            obj.children = null;
            data.push(obj);
          }
        });
      });

      if (result != true && data.length == 0) {
        this.$notify.error({
          title: "失败",
          message: "请选择筛选条件",
        });
        return;
      }
      return data;
    },
    handleEtl(row) {
      this.$confirm(
        "系统会在第二天自动执行，确定现在就要执行此画像客户标记吗？工作期间可能会影响系统性能",
        "提示",
        {
          confirmButtonText: "立即执行",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        service.$axiosDimProfileEtl({ id: row.id }).then((res) => {
          this.$notify.success({
            title: "成功",
            message: "执行命令已发送，请耐心等待",
          });
        });
      });
    },
    handleEstimate() {
      let data = this.valid();
      if (typeof data == "undefined") return;

      //console.info(data);
      this.estimateLoading = true;
      service
        .$axiosDimProfileEstimate({ labels: data })
        .then((res) => {
          this.estimateLoading = false;
          this.conditionForm.people = res.data.data;
        })
        .catch((res) => {
          this.estimateLoading = false;
          this.$notify.error({
            title: "失败",
            message: res.data.errmsg,
          });
        });
    },
    handleCondition(row) {
      this.dialogConditionVisible = true;
      this.condidtionLoading = true;
      service
        .$axiosDimProfileRead({ id: row.id })
        .then((res) => {
          //遍历处理日期型的赋值
          res.data.data.forEach((item) => {
            item.children.forEach((label) => {
              if (
                label.property == "date" &&
                label.conditionStart != null &&
                label.conditionStart != ""
              ) {
                label.conditionStart = [
                  label.conditionStart.split(",")[0],
                  label.conditionStart.split(",")[1],
                ];
              }
            });
          });
          this.labelList = res.data.data;
          this.condidtionLoading = false;
        })
        .catch((res) => {
          this.condidtionLoading = false;
        });
    },
    handleSaveCondition() {
      let data = this.valid();
      if (typeof data == "undefined") return;
      this.conditionForm.labels = data;
      this.$refs["filterForm"].validate((valid) => {
        if (valid) {
          this.condidtionSaveLoading = true;
          service
            .$axiosDimProfileCreate(this.conditionForm)
            .then((res) => {
              this.condidtionSaveLoading = false;
              if (res.data.errno == 0) {
                this.dialogConditionVisible = false;
                this.getList();
                this.$notify.success({
                  title: "成功",
                  message: "服务者画像保存成功",
                });
              } else {
                this.$notify.error({
                  title: "失败",
                  message: res.data.errmsg,
                });
              }
            })
            .catch((res) => {
              this.condidtionSaveLoading = false;
              this.$notify.error({
                title: "失败",
                message: res.data.errmsg,
              });
            });
        }
      });
    },
    btnMoreLabel(item) {
      const isHide =
        typeof item.isHide == "undefined" || item.isHide == true ? false : true;
      item.isHide = isHide;
      console.info(isHide);
      //更多标签按钮
      var index = 0;
      item.children.forEach((label) => {
        index = index + 1;
        if (index > 3) {
          label.isHide = isHide;
          console.info(label);
        }
      });
    },
  },
};
</script>










<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.el-button--text {
  padding: 0 !important;
  width: auto !important;
  margin-left: 5px !important;
}
.el-button--text span {
  margin-left: 0px !important;
}
.el-dialog__body {
  padding: 0px;
}
fieldset {
  border: 1px solid #dfe6ec;
  margin: 10px;
  padding: 10px;
}
legend {
  color: #909399;
  font-size: 23px;
}
.text-center {
  text-align: center;
}
.active {
  color: #1890ff;
  border-color: #badeff;
  background-color: #e8f4ff;
}
.label-contain {
  display: flex;
  align-items: center;
  margin: 10px 0px;
  border-bottom: 1px dashed #dfe6ec;
  padding-bottom: 5px;
}
.label-contain .title {
  width: 150px;
  min-width: 150px;
  text-align: right;
}
.condition {
  font-size: 11px;
  color: #09afff;
}
.condidtion-title {
  margin: 5px 0;
  font-size: 11px;
  font-weight: 600;
}
.symbol {
  color: #606266;
  font-size: 9px;
  margin-left: 10px;
}

.detail-container {
  width: 80%;
  padding: 20px 20px 20px 20px;
  margin: 20px auto;
}

.operate-container {
  background: #f2f6fc;
  height: 80px;
  margin: -20px -20px 0;
  line-height: 80px;
}

.operate-button-container {
  float: right;
  margin-right: 20px;
}

.table-layout {
  margin-top: 20px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  height: 60px;
  line-height: 20px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  white-space: pre-wrap;
  /* overflow: hidden; */
}

.table-cell-title {
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  background: #f2f6fc;
  text-align: center;
  font-size: 14px;
  color: #303133;
}
.el-table th.gutter {
  display: table-cell !important;
}

.el-table colgroup.gutter {
  display: table-cell !important;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.color-danger {
  color: #f56c6c;
  font-size: 18px;
}
.el-dialog .el-cascader {
  width: 400px;
}
.fixed-width .el-button--mini {
  width: auto;
  min-width: 60px;
}
.el-step.is-center .el-step__description {
  padding-left: 18%;
  padding-right: 18%;
}
.process {
  background-color: rgb(204 138 138);
  width: 100%;
  height: 15px;
  align-items: center;
  display: flex;
  align-items: center;
}

.process .completed {
  width: 60%;
  font-size: 10px;
  color: white;
}

.process .action {
  width: 40%;
  background-color: #916161;
  height: 15px;
}
</style>